export default __webpack_public_path__ + "static/media/12.42bb8f97.svg";